import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
	selector: '[fit-closest-table]',
	standalone: true
})
export class FitClosestTableDirective implements OnInit {

	constructor(private el: ElementRef) {
	}

	ngOnInit() {
		// first apply a very large colspan, to keep table layout consistent
		this.el.nativeElement.setAttribute('colspan', 100)
		// then find the table correct span among parent/siblings
		setTimeout(_ => this.patchColspan(), 20);
	}

	patchColspan() {
		const self = this.el.nativeElement;
		let table = self;
		while (table && table.tagName !== 'TABLE' && table.tagName !== 'BODY') table = table.parentNode;
		if (!table) return;
		const headers = table.querySelector('thead')?.querySelectorAll('th:not(.d-none)');
		const siblings = [...self.parentElement.children].filter(e => e !== self);
		const siblingSpan = siblings.reduce((acc, s) => acc + (s.colSpan || 1), 0);
		const filling = Math.max(1, headers?.length - siblingSpan);

		this.el.nativeElement.setAttribute('colspan', filling);
	}
}
